import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import LockIcon from '@material-ui/icons/LockOutlined';
import AccountCircle from '@material-ui/icons/AccountCircle'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import SwipeableViews from 'react-swipeable-views';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import AppBar from '@material-ui/core/AppBar';
import {FacebookLoginButton,GoogleLoginButton} from "react-social-login-buttons"
import AuthService from '../../Services/AuthService';
import CustomizedSnackbars from '../AlertMessages/SuccessMsg';


import styles from './Styles';

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};


class SignIn extends React.Component {
  constructor(props){
    super(props);
    this.state={ 
      login_username:'', 
      login_password:'',
      signup_username:'', 
      signup_password:'',
      message: '',
      signup_message: '',
      index: 0,

    }
    this.handleChange = this.handleChange.bind(this);
    this.handleIndexChange = this.handleIndexChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this.handleSignInSubmit = this.handleSignInSubmit.bind(this);
    this.handleSignUpSubmit = this.handleSignUpSubmit.bind(this);
    this.handleFacebookLogin = this.handleFacebookLogin.bind(this);
    this.googleLogin = this.googleLogin.bind(this);
    this.Auth = new AuthService();
    }
  
    handleChange = async event =>{
      this.setState({ [event.target.name]:event.target.value })
    }

    handleIndexChange = (event, index) => {
      this.setState({ index });
    };

    handleChangeIndex = index => {
      this.setState({ value: index });
    };
  
    async componentWillMount(){
      const search = this.props.location.search;
      const params = new URLSearchParams(search);
      const token = params.get('token');
      if(token!=null){
        console.log(token); 
        localStorage.setItem('id_token', token);
        localStorage.setItem('username', 'Google User');
        await this.Auth.hasLead()
        .then(res => {
          console.log(localStorage.getItem('hasLead'))
          if(res){
            console.log(res.data.lead);
            localStorage.setItem('profile',JSON.stringify(res.data.lead));
            localStorage.setItem('username',res.data.lead.name);
            window.location.reload();
            this.props.history.push('/');
          }
          else {
            window.location.reload();
            this.props.history.push('/');
          }
        })  
      }
      if(this.Auth.loggedIn())
        this.props.history.replace('/');
    }

  handleFacebookLogin(){
    this.Auth.facebookLogin()
      .then(res => {
        console.log(res);
      })
  }
  googleLogin(){
      // const url = 'https://connect-back-end.scottguo.com/auth/google?redirect_uri=http://localhost:3000/signin';
      // window.open(url, '_blank');
      // window.close();
      this.props.history.push('/google')
  }

  handleSignInSubmit = async event =>{
    event.preventDefault();
    console.log("User name : " + this.state.login_username)
    console.log("User Password : " + this.state.login_password)
    await this.Auth.login(this.state.login_username,this.state.login_password)
      .then(res =>{
        console.log('login finished')
        localStorage.setItem('username', this.state.login_username)
      })
      .catch(err =>{
          console.log("This is an error Message:" + err);
      })
    if(this.Auth.loggedIn()){
      await this.Auth.hasLead()
        .then(res => {
          console.log(localStorage.getItem('hasLead'))
          if(res){
            console.log(res.data.lead);
            localStorage.setItem('profile',JSON.stringify(res.data.lead));
            localStorage.setItem('username',res.data.lead.name);
            window.location.reload();
            this.props.history.push('/');
          }
          else {
            window.location.reload();
            this.props.history.push('/');
          }
        })  
    }
    else this.setState({message: "err"})
  }

    handleSignUpSubmit = async event =>{
      event.preventDefault();
      console.log("User name : " + this.state.signup_username)
      console.log("User Password : " + this.state.signup_password)
      localStorage.setItem('username', this.state.signup_username)
      this.Auth.signup(this.state.signup_username,this.state.signup_password)
        .then(res =>{
          this.state.index = 0;
          console.log(res)
          window.location.reload();
          this.setState({signup_message: "res"})
        })
        .catch(err =>{
            console.log("This is Error Message " + err);
        })
      }
  
  render () {
    const { classes, theme } = this.props;
  return (
    <React.Fragment>
      <CssBaseline />
      <main className={classes.layout}>
      {this.state.message=="err"?"Username or Password incorrect!":null}
      {this.state.signup_message=="res"?"You have Successfully Registered, please login":null}
      <Paper className={classes.paper}>
      <AppBar position="static" color="default">
      
      <Tabs
            value={this.state.index}
            onChange={this.handleIndexChange}
            indicatorColor="primary"
            textColor="primary"
            fullWidth
          >
            <Tab label="Login" />
            <Tab label="SignUp" />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={this.state.index}
          onChangeIndex={this.handleChangeIndex}
        >
          <TabContainer dir={theme.direction}>
          <form className={classes.form} onSubmit={this.handleSignInSubmit}>
          <Avatar className={classes.avatar}>
            <LockIcon />
          </Avatar>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="name">User Name</InputLabel>
              <Input 
                id="login_username" 
                name="login_username" 
                autoFocus 
                value={this.state.login_username} 
                onChange={evt => this.setState({
                  login_username: evt.target.value
                })}
              />
            </FormControl>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="password">Password</InputLabel>
              <Input
                name="login_password"
                type="password"
                id="login_password"
                autoComplete="current-password"
                value={this.state.login_password} 
                onChange={evt => this.setState({
                  login_password: evt.target.value
                })}
              />
            </FormControl>
            <Button
              type="submit"
              fullWidth
              variant="raised"
              color="primary"
              className={classes.submit}
            >
              Login to Connect
            </Button>
            <FacebookLoginButton onClick={this.handleFacebookLogin}/>
            <h3></h3>
            <GoogleLoginButton onClick={this.googleLogin}/>
          </form>
          </TabContainer>

          <TabContainer dir={theme.direction}>
          <form className={classes.form} onSubmit={this.handleSignUpSubmit}>
          <Avatar className={classes.avatar}>
            <AccountCircle />
          </Avatar>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="name">Enter Your User Name</InputLabel>
              <Input 
              id="signup_username" 
              name="signup_username" 
              autoComplete="name" 
              autoFocus 
              value={this.state.signup_username} 
              onChange={evt => this.setState({
                signup_username: evt.target.value
              })}
              />
            </FormControl>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="password">Enter Your Password</InputLabel>
              <Input
                name="signup_password"
                type="password"
                id="signup_password"
                autoComplete="current-password"
                value={this.state.signup_password} 
                onChange={evt => this.setState({
                  signup_password: evt.target.value
                })}
              />
            </FormControl>
            <Button
              type="submit"
              fullWidth
              variant="raised"
              color="primary"
              className={classes.submit}
            >
              Sign Up to Connect
            </Button>
            <FacebookLoginButton onClick={() => alert("Hello")}/>
            <h3></h3>
            <GoogleLoginButton onClick={this.googleLogin}/>
          </form>
          </TabContainer>        
        </SwipeableViews>
        </Paper>   
      </main>
    </React.Fragment>
  );
  }
}

SignIn.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme:true})(SignIn);


// WEBPACK FOOTER //
// ./src/components/Signin/SignIn.js